import { render, staticRenderFns } from "./InquiryComplaints.vue?vue&type=template&id=3373f86f&scoped=true&"
import script from "./InquiryComplaints.vue?vue&type=script&lang=js&"
export * from "./InquiryComplaints.vue?vue&type=script&lang=js&"
import style0 from "./InquiryComplaints.vue?vue&type=style&index=0&id=3373f86f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3373f86f",
  null
  
)

export default component.exports